<template>
  <div>
    <div
      style="
        padding: 30px;
        background: #ffffff;
        box-shadow: rgb(107 105 105 / 21%) 0px 0px 20px 0px;
        border-radius: 10px;
      "
    >
      <div
        style="
          font-size: 24px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #333333;
          margin-bottom: 20px;
        "
      >
        箱标打印
      </div>
      <div style="display: flex; flex-wrap: wrap">
        <div
          class="grid-content bg-purple"
          style="
            margin-bottom: 10px;
            min-width: 300px;
            margin-right: 20px;
            display: flex;
            align-items: center;
          "
        >
          <span class="base-form-label">
            <!-- 流水号 -->
            外箱号
          </span>
          <el-input
            style="width: 250px"
            placeholder="请输入货箱号"
            v-model="fbxbillNum"
            @keyup.enter.native="getkeyup"
            clearable
          >
          </el-input>
          <!--  @clear="getkeyup" -->
        </div>
        <div class="grid-content bg-purple" style="min-width: 285px">
          <el-button
            @click="btnClickPreview()"
            style="margin-left: 20px"
            type="primary"
            >预览</el-button
          >
          <el-button
            @click="btnClickPrint()"
            style="margin-left: 20px"
            type="primary"
            >查询</el-button
          >
        </div>
      </div>
    </div>

    <div ref="demo1" v-show="true">
      <div v-for="(item,index) in countList" :key="index">
        <div style="width:100%;min-height:340px;padding-bottom: 20px; border:1px solid black;page-break-after:always">
            <div class="header_wrap" style="height:90px;width:100%;padding: 0 10px;box-sizing: border-box;display: flex;align-items: center;justify-content: center;border-bottom:1px solid black">
                <div style="height:100%;width:130px;display: flex;justify-content: center;flex-direction: column;align-items:center;text-align: center;">
                    <div>
                        <img style="width:100px;height:36px" src="../../../assets/logo.png" alt="">
                    </div>
                    <div style="margin-top:15px">
                        <span style="font-size:11px;">www.huodaipin.com</span>
                    </div>
                </div>
                <div style="min-width:230px;border-left:1px solid black;text-align: center;height:100%">
                    <!-- <span>条形码</span> -->
                </div>
            </div>
            <div class="center" style="width:100%;display: flex;align-items:center;height:150px;font-size:12px">
                <div style="width:280px;">
                    <div style="width:100%;float:left">
                        <div style="float:left;width:100px">Product:</div>
                        <div style="float:left">{{item.product}}</div>
                    </div>
                     <div style="width:100%;float:left">
                        <div style="float:left;width:100px">CustomerCode:</div>
                        <div style="float:left">{{item.customerCode}}</div>
                    </div>
                     <div style="width:100%;float:left" v-if="!item.privateAddr">
                        <div style="float:left;width:100px">PRO:</div>
                        <div style="float:left">{{item.pro}}</div>
                    </div>
                     <div style="width:100%;float:left">
                        <div style="float:left;width:100px">Weight:</div>
                        <div style="float:left">{{item.weight}}</div>
                    </div>
                     <div style="width:100%;float:left">
                        <div style="float:left;width:100px">Vol Weight:</div>
                        <div style="float:left">{{item.cbm}}</div>
                    </div>
                     <div style="width:100%;float:left" v-if="!item.privateAddr">
                        <div style="float:left;width:100px">POS:</div>
                        <div style="float:left">{{item.pos}}</div>
                    </div>
                     <div style="width:100%;float:left">
                      <!-- 分拣码 -->
                        <div style="float:left;width:100px">Sorting Code:</div>
                        <div style="float:left">{{item.abbrInitials}}</div>
                    </div>
                     <div style="width:100%;float:left">
                        <div style="float:left;width:100px">Product Name:</div>
                        <div style="float:left">{{item.productName}}</div>
                    </div>
                </div>
                <div>
                    <!-- 条形码 -->
                </div>
            </div>
            <!-- display: flex;flex-direction:row-reverse -->
              <div style="width:100%;display: flex;flex-flow: row nowrap;justify-content: space-between;align-items: center;height:76px">
                <div style="width:100px;text-align: center;font-weight: bold;font-size:22px;">{{item.baoguan}}</div>
                <div style="text-align:left; min-width:100px; max-width:200px; padding-right: 10px;">
                        <p style="font-size:14px;font-weight: bold;">Receiver</p>
                        <p style="font-size:11px;">{{item.receiver}}</p>
                        <span style="font-size:11px">{{item.receiverAddress}}</span>
                    </div>
            </div>
            <div style="margin-top: 20px;height: 30px;display: flex;justify-content:space-between;padding:0 25px;align-items:center;">
              <div>
                <span>{{ index + 1 }} / {{ countList.length }}</span>
              </div>
                <div >
                    <div style="text-align: center;">
                        <span style="font-size:18px;font-weight: bold;">{{item.country}}</span>
                        <span style="font-size:22px;font-weight: bold;">{{item.transportType}}</span>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getLodop } from "./LodopFuncs";
export default {
  data() {
    return {
      fbxbillNum: "",
      countList: [],
    };
  },
  watch: {},

  methods: {
    btnClickPreview() {
      this.axios
        .get(`/busFbx/downFBXOrderLabel/${this.fbxbillNum}`)
        .then((res) => {
          if (res.data.code == 200) {
            const url = res.data.data
            window.open(url)
          } else {
            this.$message.info(res.data.message);
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    btnClickPrint() {
      this.getkeyup();
    },
    handleSearch() {},
    getkeyup(e) {
      this.axios
        .get(`/busFbx/downFBXOrderLabel/${this.fbxbillNum}`)
        .then((res) => {
          if (res.data.code == 200) {
            const url = res.data.data
            let LODOP = getLodop();
            if(typeof LODOP === 'undefined') return false;

            LODOP.PRINT_INIT('箱标'); //打印初始化
            LODOP.ADD_PRINT_PDF(0,0,'100%','100%',url)
            // LODOP.SET_LICENSES("","539CA9C3D5E0D2F5848CA278799DE2F0292","",""); //调用会员
            LODOP.PRINT(); //打印
          } else {
            this.$message.info(res.data.message);
          }
        })
        .catch((res) => {
          console.log(res);
        });
      // let user = this.sessionGetUserInfo();
      // this.axios
      //   .get(`/carrier/order/queryLabelOrderByOrderNo?fbxOrderNo=${this.fbxbillNum}&customerId=${user.customerid}`)
      //   // .get(
      //   //   `/carrier/order/queryLabelOrderByBoxNo?fbxBoxNo=FBA15F0R6SPYU000001&customerId=19007193600`
      //   // )

      //   .then((res) => {
      //     if (res.data.code !== 200) return this.$message.info(res.data.message||"暂无该订单数据");
      //     if (!(Array.isArray(res.data.datas) && res.data.datas.length)) return this.$message.info("暂无该订单数据");
      //     this.countList = res.data.datas;
      //     const first = res.data.datas[0]
      //     this.or
      //     this.$nextTick(() => {
      //       let LODOP = getLodop();
      //       if(typeof LODOP === 'undefined') return false;
      //       LODOP.PRINT_INIT("订单"); //打印初始化
      //       LODOP.SET_PRINT_PAGESIZE(1, "150mm", "150mm"); //设定纸张大小
      //       window.a = this.$refs.demo1;
      //       LODOP.PRINT_INIT(""); //初始化
      //       if (!first.privateAddr) LODOP.ADD_PRINT_BARCODE(50,294,45,230,"Code39",first.pro.toLocaleUpperCase()); //竖型条形码 上边距 左边距 宽 高
      //       LODOP.SET_PRINT_STYLEA(0, "Angle", 90);
      //       LODOP.ADD_PRINT_BARCODE(20,146,250,65, "Code93", first.boxNumber); //横条形码 上边距 左边距 宽 高
      //       LODOP.SET_PRINT_STYLEA(0,"QRCodeErrorLevel","H")
      //       a.childNodes.forEach(v => {
      //         LODOP.ADD_PRINT_HTM(0, 0, "100%", "100%", v.innerHTML)
      //         LODOP.NewPageA()
      //       })
      //       // LODOP.ADD_PRINT_HTM(9, 4, "100%", "100%", a.innerHTML);
      //       LODOP.SET_LICENSES("","539CA9C3D5E0D2F5848CA278799DE2F0292","",""); //调用会员
      //       LODOP.PREVIEW(); //预览打印
      //       // LODOP.PRINT(); //直接打印

      //     });
      //   })
      //   .catch((res) => {
      //     console.log(res);
      //   });
    }
  },
  created() {},

  mounted() {
    this.$nextTick(() => {
      window.a = this.$refs.strHtml;
    });
  },
};
</script>
<style lang="less" scoped>
.grid-content {
  font-size: 0;
}
.base-form-label {
  display: inline-block;
  min-width: 60px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
  text-align: right;
  margin-right: 20px;
}

.tableBorderMy {
  border: 1px solid #e7e7e7;
}
.tableBorderMyBtn {
  border-bottom: 1px solid #e7e7e7;
}
// .table-content-item {
//   line-height: 20px;
//   padding: 10px 5px;
// }
.myCursor {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/PersonalCenter/Scanprint/ScanLodop.vue